var map = {
	"./de.json": 380,
	"./en.json": 381,
	"./es.json": 382,
	"./fr.json": 383,
	"./it.json": 384,
	"./skins/default.en.json": 635,
	"./skins/education.de.json": 636,
	"./skins/education.en.json": 637,
	"./skins/education.es.json": 638,
	"./skins/education.fr.json": 639,
	"./skins/education.it.json": 640,
	"./skins/museum.de.json": 641,
	"./skins/museum.en.json": 642,
	"./skins/museum.es.json": 643,
	"./skins/museum.fr.json": 644,
	"./skins/museum.it.json": 645,
	"./tenants/ancot.it.json": 646,
	"./tenants/csp.en.json": 647,
	"./tenants/csp.it.json": 648,
	"./tenants/ekom.it.json": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 634;